import {OrderSupportingFile} from "@/entities/order-supporting-file";
import {Report} from "@/entities/report";

export interface FileWithComment {
  file: File
  comment?: string
}

export interface ReplaceFile extends FileWithComment {
  existing: OrderSupportingFile | Report;
}

export interface UploadError {
  fileName: string;
  code: string;
  technicalMessage?: string;
}

export interface SyncFilesResult {
  success: boolean;
  addedCount: number;
  errors: UploadError[];
}

export enum UploadErrorCode {
  INVALID_PDF = 'INVALID_PDF',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  REPLACE_FAILED = 'REPLACE_FAILED',
  BULK_FAILED = 'BULK_FAILED',
  DELETE_FAILED = 'DELETE_FAILED',
  UPDATE_FAILED = 'UPDATE_FAILED',
  FINALIZATION_FAILED = 'FINALIZATION_FAILED',
  UNKNOWN = 'UNKNOWN',
  FILE_EXISTS = 'FILE_EXISTS',
}

export function createUploadError(fileName: string, code: UploadErrorCode, technicalMessage?: string): UploadError {
  return { fileName, code, technicalMessage };
}
